import { useState } from 'react'
import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import PaymentGatewayListing from '@/modules/bank/components/PaymentGateway/components/PaymentGatewayListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useQueryGetPaymentGateway from '@/modules/bank/api/hooks/useQueryGetPaymentGateway'
import useQueryChannelCounts from '@/modules/bank/api/hooks/useQueryChannelCounts'
import type { PaymentChannelTab } from '@/modules/bank/type'

export type TabValue = PaymentChannelTab | 'maintenance'

function PaymentGatewayPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()
	const [activeTab, setActiveTab] = useState<TabValue>('QR')

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		bankProviderName: searchQuery,
		...(activeTab !== 'maintenance' ? { channel: activeTab } : {}),
	}

	const { data, isLoading } = useQueryGetPaymentGateway(payload, {
		enabled: activeTab !== 'maintenance',
	} as any)

	const { data: channelCounts } = useQueryChannelCounts()

	const listingData = activeTab === 'maintenance' ? [] : (data?.data ?? [])
	const listingTotal = activeTab === 'maintenance' ? 0 : (data?.total ?? 0)

	return (
		<PageContainer>
			<PaymentGatewayListing
				data={listingData}
				total={listingTotal}
				isLoading={activeTab !== 'maintenance' && isLoading}
				activeTab={activeTab}
				onTabChange={setActiveTab}
				channelCounts={channelCounts}
			/>
		</PageContainer>
	)
}

const GuardedPaymentGatewayPage = withUserPermission(PaymentGatewayPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_BANK_ACCOUNT],
})

export default GuardedPaymentGatewayPage
